<template>
  <div class="login">
    <h1>Вход</h1>
    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="email" required>
      </div>
      <div class="form-group">
        <label for="password">Пароль:</label>
        <input type="password" id="password" v-model="password" required>
      </div>
      <button type="submit">Войти</button>
    </form>
    <br>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { createToaster } from "@meforma/vue-toaster";


export default {
  setup(){

    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const toaster = createToaster()
    const email = ref('')
    const password = ref('')
    // const email = ref('89995283039@alt.gr')
    // const password = ref('12qwerty43')

    const handleSubmit = async () => {      

      try{
        await store.dispatch('login',{
          email:email.value,
          password:password.value
        })
        router.push(route.query.redirect || '/')
      } catch(err){
        toaster.error(err.message)
      }
      
    }

    return {handleSubmit,email,password}
  },
 
};
</script>


<style scoped>
.login {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>
